export const configDev = {
  baseUrl: "https://pub-kong-testenv02.uat.aurora.io/dev-v1",
};
